module.exports = __webpack_public_path__ + "img/de_small_logo.80ce395f.png";